export default {"src":"/_next/static/media/total-earnings.9b40804b.svg","height":30,"width":32};